function replaceImage(image: string) {
  return {
    color: image.split("||")[1],
    src: image.split("||")[0],
  };
}

export function getAdditional(data: any) {
  const additional = [
    data["Additional Image Addresses 1"] &&
      replaceImage(data["Additional Image Addresses 1"]),
    data["Additional Image Addresses 2"] &&
      replaceImage(data["Additional Image Addresses 2"]),
    data["Additional Image Addresses 3"] &&
      replaceImage(data["Additional Image Addresses 3"]),
    data["Additional Image Addresses 4"] &&
      replaceImage(data["Additional Image Addresses 4"]),
    data["Additional Image Addresses 5"] &&
      replaceImage(data["Additional Image Addresses 5"]),
    data["Additional Image Addresses 6"] &&
      replaceImage(data["Additional Image Addresses 6"]),
    data["Additional Image Addresses 7"] &&
      replaceImage(data["Additional Image Addresses 7"]),
    data["Additional Image Addresses 8"] &&
      replaceImage(data["Additional Image Addresses 8"]),
    data["Additional Image Addresses 9"] &&
      replaceImage(data["Additional Image Addresses 9"]),
    data["Additional Image Addresses 10"] &&
      replaceImage(data["Additional Image Addresses 10"]),
  ];

  const additionalClearUndefined: any[] = [];

  for(const x of additional){
    if (x !== undefined || x !== "") {
      additionalClearUndefined.push(x);
    } else {
      additionalClearUndefined.push("");
    }
  }

  return additionalClearUndefined;
}
